import React, { useState } from "react";
import axios from "axios";
import { Contactusmessage } from "../Utils/urls";
import { useNavigate } from "react-router-dom";
import { getsessionuser } from '../Utils/sessions';
import Loadingspinner from "../Components/loading";
import Universalheader from "../Headers/universalheader";
import {
    Alert, AlertTitle, Box, Paper, Typography, TextField, Button,
    Fade, Grow, Divider, Breadcrumbs, Link as MuiLink,
    Accordion, AccordionSummary, AccordionDetails
} from "@mui/material";
import {
    SendRounded, CheckCircleRounded, WorkspacePremiumRounded,
    VerifiedRounded, BoltRounded, ShieldRounded, ExpandMoreRounded,
    HelpOutlineRounded
} from "@mui/icons-material";

// ─── Design tokens — kept consistent with the rest of the app ──────────────
const BRAND = '#900f20';
const BRAND_DARK = '#670600';
const INK = '#1c1a1a';
const CANVAS = '#f6f5f3';
const MUTED = '#78726f';
const SERIF = 'Georgia, "Times New Roman", serif';

const fieldSx = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '12px', bgcolor: '#fff', transition: 'box-shadow .2s ease',
        '& fieldset': { borderColor: 'rgba(28,26,26,0.12)' },
        '&:hover fieldset': { borderColor: BRAND },
        '&.Mui-focused fieldset': { borderColor: BRAND, borderWidth: '1.5px' },
        '&.Mui-focused': { boxShadow: '0 0 0 4px rgba(144,15,32,0.08)' },
    },
    '& .MuiInputLabel-root.Mui-focused': { color: BRAND },
};

const features = [
    {
        title: 'Real people, real help',
        body: 'Your message goes straight to our support team — not a queue.',
    },
    {
        title: 'Secure & confidential',
        body: 'Your details are only ever used to respond to you.',
    },
    {
        title: 'Fast response times',
        body: 'We typically reply within one business day.',
    },
];

const stats = [
    { value: '500+', label: 'Verified properties' },
    { value: '10K+', label: 'Students helped' },
    { value: '20+', label: 'Campuses covered' },
];

const badges = [
    { icon: WorkspacePremiumRounded, label: 'Top rated' },
    { icon: VerifiedRounded, label: 'Verified listings' },
    { icon: BoltRounded, label: 'Fast support' },
    { icon: ShieldRounded, label: 'Secure & safe' },
];

// ─── FAQ content — merged in from the standalone Faqs page ────────────────
const questions = [
    {
        id: 1,
        question: "What is Eazistey",
        answer: "Eazistey is an accommodation finder platform. We are a one-click accommodation platform providing free assistance to tenants. We serve over 100 cities, and partnered with multiple field agents and property consultants who provide us updated listings. After receiving your preferences like distance from you, budget, bedroom configurations, safety etc. our platform finds out the apartments which fulfill your needs.",
    },
    {
        id: 2,
        question: "What does the rent include?",
        answer: "Rent includes all other payments included by the property owner in the other payments section.",
    },
    {
        id: 3,
        question: "Are the properties safe and convenient?",
        answer: "Most of the properties are safe and are under CCTV surveillance. They are also in close proximity to major access roads and have multiple transport links that connect them to the entire city.",
    },
    {
        id: 4,
        question: "Are the prices negotiable?",
        answer: "We make sure that you get the best value for your money. The prices that you see on our website are absolute and inherent. However you can get special offers exclusively from Eazistey.",
    },
    {
        id: 5,
        question: "Do I need to pay a deposit? When will I get my deposit back?",
        answer: "All deposits and other payments are sorted out between you and the property manager or caretaker.",
    },
    {
        id: 6,
        question: "Will I have basic amenities and appliances?",
        answer: "Yes, most of the properties provide basic amenities and appliances.",
    },
    {
        id: 7,
        question: "Is the google map location accurate?",
        answer: "Yes, we've made sure that the coordinates are accurate and navigate you to the exact property of your choosing.",
    },
];

const Help = () => {

    const navigate = useNavigate();

    const user = getsessionuser()

    const [message, setmessage] = useState('');
    const [campus, setcampus] = useState(user?.campus);

    const [loading, setloading] = useState(false);
    const [email, setemail] = useState(user?.email);
    const [username, setusername] = useState(user?.username);
    const [subject, setsubject] = useState('');
    const [error, seterror] = useState('');
    const [errordiv, seterrordiv] = useState(false);
    const [success, setsuccess] = useState('');
    const [successdiv, setsuccessdiv] = useState(false);

    // FAQ accordion — which question is currently open (presentation-only state)
    const [expandedfaq, setexpandedfaq] = useState(false);

    const sendmessage = () => {
        seterror(null)
        if (!message) {
            seterrordiv(true)
            seterror("Enter message to send")
        } else if (!email) {
            seterrordiv(true)
            seterror("Enter an email address")
        }
        else if (!username) {
            seterrordiv(true)
            seterror("Enter your full name")
        }
        else if (!campus) {
            seterrordiv(true)
            seterror("Enter your campus")
        }
        else if (!subject) {
            seterrordiv(true)
            seterror("Specify message subject")
        }
        else {
            setloading(true)
            axios.post(Contactusmessage, {
                subject: subject,
                username: username,
                email: email,
                message: message,
                campus: campus
            }).then(response => {
                setloading(false)
                if (!response.data.error) {
                    setsuccess(response.data.success)
                    setTimeout(() => {
                        setsuccess("")
                    }, 5000);
                    setmessage("")
                    setsubject("")
                } else {
                    seterror(response.data.message)
                }
                // 
            }).catch(error => {
                setloading(false)
                seterror("Sorry there was an error try again later")
            });
        }
    }


    return (
        <Box sx={{ bgcolor: CANVAS, minHeight: '100vh', pb: 10 }}>
            {loading && <Loadingspinner />}

            <Universalheader />

            {/* Breadcrumb */}
            <Box sx={{ px: { xs: 2, md: 6 }, mt: 3, mb: 1 }}>
                <Breadcrumbs separator="›" sx={{ '& .MuiBreadcrumbs-separator': { color: 'rgba(28,26,26,0.3)' } }}>
                    <MuiLink
                        component="button" underline="hover" onClick={() => navigate('/')}
                        sx={{ color: BRAND, fontWeight: 600, fontSize: '0.875rem' }}
                    >
                        Home
                    </MuiLink>
                    <MuiLink
                        component="button" underline="hover" onClick={() => navigate('/nav/hostels')}
                        sx={{ color: BRAND, fontWeight: 600, fontSize: '0.875rem' }}
                    >
                        Properties
                    </MuiLink>
                    <Typography sx={{ color: INK, fontWeight: 600, fontSize: '0.875rem' }}>Help & FAQs</Typography>
                </Breadcrumbs>
            </Box>

            {(error?.length > 0 || success?.length > 0) && (
                <Box sx={{ px: { xs: 2, md: 6 }, mt: 2 }}>
                    {error?.length > 0 && (
                        <Grow in={!!error}>
                            <Alert severity="error" variant="filled" sx={{ borderRadius: '12px', mb: 2, boxShadow: '0 4px 14px rgba(144,15,32,0.15)' }}>
                                <AlertTitle sx={{ fontWeight: 700 }}>Error</AlertTitle>
                                {error}
                            </Alert>
                        </Grow>
                    )}
                    {success?.length > 0 && (
                        <Grow in={!!success}>
                            <Alert severity="success" variant="filled" sx={{ borderRadius: '12px', mb: 2, boxShadow: '0 4px 14px rgba(46,125,50,0.15)' }}>
                                <AlertTitle sx={{ fontWeight: 700 }}>Success</AlertTitle>
                                {success}
                            </Alert>
                        </Grow>
                    )}
                </Box>
            )}

            <Fade in timeout={500}>
                <Box sx={{
                    width: '95%', margin: "auto", bgcolor: '#ffffff',
                    borderBottom: '1px solid rgba(28,26,26,0.06)',
                }}>
                    <Box sx={{
                        width: '100%', px: { xs: 2, md: 6 }, py: { xs: 4, md: 7 },
                        display: 'flex', flexDirection: { xs: 'column', md: 'row' },
                        alignItems: 'center', gap: { xs: 5, md: 8 },
                    }}>

                        {/* Left — pitch */}
                        <Box sx={{ flex: '1 1 0', width: '100%' }}>
                            <Typography sx={{
                                fontFamily: SERIF, fontWeight: 700, color: INK, lineHeight: 1.15,
                                fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                            }}>
                                Talk to our{' '}
                                <Box component="span" sx={{ fontStyle: 'italic', color: BRAND }}>support</Box>
                                {' '}team
                            </Typography>

                            <Typography sx={{ color: MUTED, mt: 2, mb: 4, fontSize: '1.05rem', maxWidth: 460 }}>
                                Get in touch with our team for any questions, issues, or feedback
                                {user?.username ? `, ${user.username}` : ''} — we're here to help.
                            </Typography>

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, mb: 4 }}>
                                {features.map((f) => (
                                    <Box key={f.title} sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
                                        <CheckCircleRounded sx={{ color: BRAND, fontSize: 22, mt: '2px' }} />
                                        <Box>
                                            <Typography sx={{ fontWeight: 700, color: INK, fontSize: '0.98rem' }}>
                                                {f.title}
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: MUTED }}>
                                                {f.body}
                                            </Typography>
                                        </Box>
                                    </Box>
                                ))}
                            </Box>

                            <Typography variant="body2" sx={{ color: MUTED }}>
                                Looking for a property instead?{' '}
                                <MuiLink
                                    component="button" underline="hover"
                                    onClick={() => navigate('/nav/hostels')}
                                    sx={{ color: BRAND, fontWeight: 700, fontSize: 'inherit' }}
                                >
                                    Click here
                                </MuiLink>
                            </Typography>
                        </Box>

                        {/* Right — form */}
                        <Box sx={{ flex: '1 1 0', width: '100%' }}>
                            <Paper
                                elevation={0}
                                sx={{
                                    borderRadius: '22px', border: '1px solid rgba(28,26,26,0.07)', bgcolor: 'white',
                                    p: { xs: 2.5, sm: 4 }, boxShadow: '0 12px 32px rgba(28,26,26,0.06)',
                                }}
                            >
                                <Typography sx={{ fontFamily: SERIF, fontWeight: 700, color: INK, fontSize: '1.3rem', mb: 3 }}>
                                    Please enter your information
                                </Typography>

                                {!user && (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
                                        <TextField
                                            label="Full name" value={username} onChange={(e) => setusername(e.target.value)}
                                            size="small" sx={{ ...fieldSx, flex: '1 1 200px' }}
                                        />
                                        <TextField
                                            label="Email" type="email" value={email} onChange={(e) => setemail(e.target.value)}
                                            size="small" sx={{ ...fieldSx, flex: '1 1 200px' }}
                                        />
                                        <TextField
                                            label="Campus" value={campus} onChange={(e) => setcampus(e.target.value)}
                                            size="small" sx={{ ...fieldSx, flex: '1 1 200px' }}
                                        />
                                        <TextField
                                            label="Subject" value={subject} onChange={(e) => setsubject(e.target.value)}
                                            size="small" sx={{ ...fieldSx, flex: '1 1 200px' }}
                                        />
                                    </Box>
                                )}

                                {user && (
                                    <Box sx={{ mb: 2 }}>
                                        <TextField
                                            label="Subject" value={subject} onChange={(e) => setsubject(e.target.value)}
                                            fullWidth size="small" sx={fieldSx}
                                            helperText="A short, specific subject helps us route your message faster."
                                        />
                                    </Box>
                                )}

                                <TextField
                                    label="Message" value={message} onChange={(e) => setmessage(e.target.value)}
                                    fullWidth multiline minRows={5} sx={{ ...fieldSx, mb: 3 }}
                                />

                                <Button
                                    onClick={sendmessage}
                                    variant="contained"
                                    disableElevation
                                    fullWidth
                                    startIcon={<SendRounded sx={{ fontSize: 18 }} />}
                                    sx={{
                                        borderRadius: '999px', py: 1.5, textTransform: 'none',
                                        fontWeight: 700, fontSize: '0.95rem', letterSpacing: '0.2px',
                                        bgcolor: BRAND, boxShadow: '0 6px 18px rgba(144,15,32,0.25)',
                                        transition: 'transform .15s ease, box-shadow .15s ease',
                                        '&:hover': { bgcolor: BRAND_DARK, boxShadow: '0 8px 22px rgba(144,15,32,0.32)', transform: 'translateY(-1px)' },
                                        '&:active': { transform: 'translateY(0)' },
                                    }}
                                >
                                    Send message
                                </Button>
                            </Paper>
                        </Box>
                    </Box>
                </Box>
            </Fade>

            {/* ─── FAQ section — merged in from the standalone Faqs page ───────── */}
            <Box sx={{ width: '95%', margin: 'auto', py: { xs: 6, md: 8 } }}>
                <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 5 } }}>
                    <Box sx={{
                        display: 'inline-flex', alignItems: 'center', gap: 1, mb: 2,
                        px: 2, py: 0.75, borderRadius: '999px', bgcolor: 'rgba(144,15,32,0.06)',
                    }}>
                        <HelpOutlineRounded sx={{ fontSize: 18, color: BRAND }} />
                        <Typography variant="body2" sx={{ color: BRAND, fontWeight: 700 }}>
                            Frequently asked questions
                        </Typography>
                    </Box>
                    <Typography sx={{
                        fontFamily: SERIF, fontWeight: 700, color: INK,
                        fontSize: { xs: '1.75rem', md: '2.25rem' },
                    }}>
                        Answers to common questions
                    </Typography>
                    <Typography sx={{ color: MUTED, mt: 1.5, maxWidth: 520, mx: 'auto' }}>
                        Can't find what you're looking for? Send us a message above and we'll get back to you.
                    </Typography>
                </Box>

                <Box sx={{ maxWidth: 760, mx: 'auto' }}>
                    {questions.map((val) => (
                        <Accordion
                            key={val.id}
                            expanded={expandedfaq === val.id}
                            onChange={() => setexpandedfaq(expandedfaq === val.id ? false : val.id)}
                            disableGutters
                            elevation={0}
                            sx={{
                                bgcolor: 'white',
                                border: '1px solid rgba(28,26,26,0.08)',
                                borderRadius: '14px !important',
                                mb: 1.5,
                                overflow: 'hidden',
                                '&:before': { display: 'none' },
                                transition: 'border-color .2s ease, box-shadow .2s ease',
                                ...(expandedfaq === val.id && {
                                    borderColor: 'rgba(144,15,32,0.3)',
                                    boxShadow: '0 8px 24px rgba(144,15,32,0.08)',
                                }),
                            }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreRounded sx={{ color: expandedfaq === val.id ? BRAND : MUTED }} />}
                                aria-controls={`faq-${val.id}-content`}
                                id={`faq-${val.id}-header`}
                                sx={{ px: { xs: 2, sm: 3 }, py: 0.5 }}
                            >
                                <Typography sx={{
                                    fontWeight: 700,
                                    color: expandedfaq === val.id ? BRAND : INK,
                                    fontSize: '0.98rem',
                                }}>
                                    {val.question}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ px: { xs: 2, sm: 3 }, pt: 0, pb: 3 }}>
                                <Typography variant="body2" sx={{ color: MUTED, lineHeight: 1.7 }}>
                                    {val.answer}
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Box>
            </Box>

            {/* Trust section */}
            <Box sx={{ width: '100%', bgcolor: BRAND_DARK, color: 'white', py: { xs: 6, md: 8 }, px: { xs: 2, md: 6 } }}>
                <Typography sx={{
                    fontFamily: SERIF, fontWeight: 700, textAlign: 'center', lineHeight: 1.25,
                    fontSize: { xs: '1.6rem', md: '2.2rem' }, maxWidth: 760, mx: 'auto',
                }}>
                    We're the <Box component="span" sx={{ fontStyle: 'italic', color: '#f2b8a8' }}>trusted</Box> student housing platform
                </Typography>

                <Box sx={{
                    display: 'flex', flexWrap: 'wrap', justifyContent: 'center',
                    gap: { xs: 4, md: 8 }, mt: 5,
                }}>
                    {stats.map((s) => (
                        <Box key={s.label} sx={{ textAlign: 'center', minWidth: 120 }}>
                            <Typography sx={{ fontFamily: SERIF, fontWeight: 700, fontSize: { xs: '2rem', md: '2.6rem' } }}>
                                {s.value}
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)', mt: 0.5 }}>
                                {s.label}
                            </Typography>
                        </Box>
                    ))}
                </Box>

                <Divider sx={{ borderColor: 'rgba(255,255,255,0.12)', my: 5, maxWidth: 900, mx: 'auto' }} />

                <Box sx={{
                    display: 'flex', flexWrap: 'wrap', justifyContent: 'center',
                    gap: { xs: 3, md: 5 },
                }}>
                    {badges.map((b) => {
                        const Icon = b.icon;
                        return (
                            <Box key={b.label} sx={{ display: 'flex', alignItems: 'center', gap: 1, opacity: 0.85 }}>
                                <Icon sx={{ fontSize: 20, color: '#f2b8a8' }} />
                                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                    {b.label}
                                </Typography>
                            </Box>
                        );
                    })}
                </Box>

                <Typography variant="caption" sx={{ display: 'block', textAlign: 'center', color: 'rgba(255,255,255,0.5)', mt: 4 }}>
                    Some of our achievements
                </Typography>
            </Box>
        </Box>
    )
}

export default Help;